import { render, staticRenderFns } from "./BaseCurrency.vue?vue&type=template&id=e5c8d5fa&"
import script from "./BaseCurrency.vue?vue&type=script&lang=js&"
export * from "./BaseCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports